export default "__VITE_ASSET__Ces2MjPF__"